import React, { useState, useEffect } from "react";
import { Button, FormGroup, Row, Col, Label, Form, Modal, ModalHeader, ModalBody, ModalFooter, Input } from 'reactstrap';
import { NotificationManager } from "react-notifications";
import { AppsClient } from "services";
import { Trans } from "react-i18next";
import DateRange from "../../components/common/Tables/DateRange"

const SyncModal = ({ modal, toggle, id, t, setLoading, showDateField }) => {
    const apps_client = AppsClient()

    const syncs_initial = {
        'sync_products': true,
        'sync_customers': true,
        'sync_orders': true,
    }

    const [syncs, setSyncs] = useState(syncs_initial);

    const [fromDate, setFromDate] = useState(null)
    const [toDate, setToDate] = useState(null)

    const isFormValid = () => {
        return Object.values(syncs).some(value => value) && (showDateField ? (fromDate && toDate) : true)
    }

    // ----------------------------------

    const Sync = async (element) => {
        try {
            let params = {}
            params['from_date'] = fromDate.format('YYYY-MM-DD')
            params['to_date'] = toDate.format('YYYY-MM-DD')

            const resp = await apps_client.get(`applications/${id}/sync/${element}`, {
                params,
            })
            return resp.data
        } catch (err) {
            throw new Error(`Couldn't sync ${element}: ${err.message}`)
        }
    }

    async function syncActions() {
        const endpoints = Object.entries(syncs)
            .filter(([key, value]) => value)
            .map(([key]) => key);

        for (const endpoint of endpoints) {
            try {
                const data = await Sync(endpoint);
                NotificationManager.success(data.message)
            } catch (error) {
                console.error(`Error in ${endpoint}:`, error);
                NotificationManager.error(error?.message || t("Couldn't update"))
                // Handle the error as needed
            }
        }
        setLoading(false)
        toggle()
    }

    const HandleSubmit = () => {
        setLoading(true)
        syncActions()
    }
    // ----------------------------------

    const SyncCheck = ({ label, field }) => (
        <FormGroup>
            <FormGroup check>
                <Input type="checkbox" checked={syncs[field]} onChange={(e) => setSyncs({ ...syncs, [field]: !syncs[[field]] })} />
                <Label check> {label} </Label>
            </FormGroup>
        </FormGroup>
    );

    const onChangeFromDateHandler = (v) => {
        setFromDate(v)
        console.log(v)
    }

    const onChangeToDateHandler = (v) => {
        setToDate(v)
        console.log(v.format('YYYY-MM-DD'))
    }

    return (
        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle}><Trans>Sync Data</Trans></ModalHeader>
            <ModalBody style={{ overflowY: 'visible' }}>
                <Form>
                    <Row>
                        <div className="col-12 mb-3">
                            <SyncCheck label={t("Sync Products")} field={'sync_products'} />
                        </div>
                        <div className="col-12 mb-3">
                            <SyncCheck label={t("Sync Customers")} field={'sync_customers'} />
                        </div>
                        <div className="col-12 mb-3">
                            <SyncCheck label={t("Sync Invoices")} field={'sync_orders'} />

                            {showDateField && <div className="row mt-4">
                                <div className="col pl-4">
                                    <FormGroup >
                                        <Label > <Trans>Date Range *</Trans> </Label>
                                        <DateRange
                                            t={t}
                                            dateFormat="YYYY-MM-DD"
                                            fromDate={fromDate}
                                            toDate={toDate}
                                            onFromDateChange={(v) => onChangeFromDateHandler(v)}
                                            onToDateChange={(v) => onChangeToDateHandler(v)}
                                            fromPlaceholderText={t('From Date')}
                                            toPlaceholderText={t('To Date')}
                                        />
                                    </FormGroup>
                                </div>
                            </div>
                            }

                        </div>
                    </Row>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" disabled={!isFormValid()} onClick={HandleSubmit}><Trans>Start Sync</Trans></Button>
            </ModalFooter>
        </Modal>
    )
}

export default SyncModal

